<div class="profile-container">

    <div *ngIf="profInit && !showProfile">
        <mat-card class="csp1">
            <p class="csp2">
                There is no Folio Selected. Please select Folio.
            </p>
        </mat-card>
    </div>
     <div class="profile-details" *ngIf="showProfile">
        <div fxLayout="row wrap" fxLayout.lt-md="column wrap" fxLayoutGap="4%">
            <div fxFlex>
                <mat-card>
                    <mat-card-header>
                        <div fxLayout="row">
                            <mat-card-title fxFlex="90">
                                <h4> Personal information</h4>
                            </mat-card-title>
                            <div fxFlex="10" class="more-vert-icon">

                            </div>
                        </div>

                        <div class="profile-card-icon">
                            <img src="./assets/images/profile_icon.jpg" alt="avadar">
                        </div>
                    </mat-card-header>
                    <mat-card-content>
                        <div *ngFor="let personal of personaldetails">
                            <div>
                                <h5 class="csp3">name</h5>
                                <div *ngIf="showProfile && personal.INV_NAME; then nameavail; else noname">
                                </div>
                                <ng-template #nameavail>
                                    <p>{{personal.INV_NAME}}</p>
                                </ng-template>
                                <ng-template #noname>
                                    <p>Not Applicable</p>
                                </ng-template>
                                <hr>
                                <h5 class="csp3">address</h5>
                                <div *ngIf="showProfile && personal.ADDRESS1; then addressavail; else noaddress">
                                </div>
                                <ng-template #noaddress>
                                    <p>Not Applicable</p>
                                </ng-template>
                                <ng-template #addressavail><span>{{personal.ADDRESS1}}</span><br>
                                    <span>{{personal.ADDRESS2}}</span><br>
                                    <span>{{personal.ADDRESS3}}</span></ng-template>
                                <hr>
                                <h5 class="csp3">Date of birth</h5>
                                <div *ngIf="showProfile && personal.DATE_OF_BIRTH; then birthavail; else nobirth">
                                </div>
                                <ng-template #nobirth>
                                    <p>Not Applicable</p>
                                </ng-template>
                                <ng-template #birthavail></ng-template>
                                <p>{{personal.DATE_OF_BIRTH}}</p>
                                <hr>
                                <h5 class="csp3">email</h5>
                                <div *ngIf="showProfile && personal.EMAIL; then emailavail; else noemail">
                                </div>
                                <ng-template #noemail>
                                    <p>Not Applicable</p>
                                </ng-template>
                                <ng-template #emailavail>
                                    <p>{{personal.EMAIL}}</p>
                                </ng-template>
                                <hr>
                                <h5 class="csp3">Mobile number</h5>
                                <div *ngIf="showProfile && personal.MOBILE_NO; then numberavail; else nonumber">
                                </div>
                                <ng-template #nonumber>
                                    <p>Not Applicable</p>
                                </ng-template>
                                <ng-template #numberavail>
                                    <p>{{personal.MOBILE_NO}}</p>
                                </ng-template>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
            <div fxFlex>
                <mat-card>
                    <mat-card-header>
                        <div fxLayout="row">
                            <mat-card-title fxFlex="90">
                                <h4>Bank account details</h4>
                            </mat-card-title>
                            <div fxFlex="10" class="more-vert-icon">

                            </div>
                        </div>
                        <div class="profile-card-icon">
                            <img src="./assets/images/bank_icon.jpg" alt="avadar">
                        </div>
                    </mat-card-header>
                    <mat-card-content>
                        <div *ngFor="let account of accountdetails">
                            <div>
                                <h5 class="csp3">bank & branch</h5>
                                <div *ngIf="showProfile && account.BANKNAME; then bankavail; else nobank">
                                </div>
                                <ng-template #nobank>
                                    <p>Not Applicable</p>
                                </ng-template>
                                <ng-template #bankavail>
                                    <span>{{account.BANKNAME}}</span><br>
                                    <span>{{account.BRANCHNAME}}</span>
                                </ng-template>
                                <hr>
                                <h5 class="csp3">account number</h5>
                                <div *ngIf="showProfile && account.ACNO; then accountavail; else noaccount">
                                </div>
                                <ng-template #noaccount>
                                    <p>Not Applicable</p>
                                </ng-template>
                                <ng-template #accountavail>
                                    <p>{{account.ACNO}}</p>
                                </ng-template>

                                <hr>
                                <h5 class="csp3">account type</h5>
                                <div *ngIf="showProfile && account.ACTYPE; then typeavail; else notype">
                                </div>
                                <ng-template #notype>
                                    <p>Not Applicable</p>
                                </ng-template>
                                <ng-template #typeavail>
                                    <p>{{account.ACTYPE}}</p>
                                </ng-template>
                                <hr>
                                <h5 class="csp3">ifsc code</h5>
                                <div *ngIf="showProfile && account.NEFT_IFSC_CODE; then ifscavail; else noifsc">
                                </div>
                                <ng-template #noifsc>
                                    <p>Not Applicable</p>
                                </ng-template>
                                <ng-template #ifscavail>
                                    <p>{{account.NEFT_IFSC_CODE}}</p>
                                </ng-template>
                                <hr>
                                <h5 class="csp3">TAX Status</h5>
                                <div *ngIf="showProfile && taxstatus; then TAXavail; else noTAX">
                                </div>
                                <ng-template #noTAX>
                                    <p>Not Applicable</p>
                                </ng-template>
                                <ng-template #TAXavail>
                                    <p>{{taxstatus}}</p>
                                </ng-template>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
            <div fxFlex>
                <mat-card>
                    <mat-card-header>
                        <div fxLayout="row">
                            <mat-card-title fxFlex="90">
                                <h4 >Joint holder information</h4>
                            </mat-card-title>
                            <div fxFlex="10" class="more-vert-icon">

                            </div>
                        </div>
                        <div class="profile-card-icon">
                            <img src="./assets/images/usergroup_icon.png" alt="avadar">
                        </div>
                    </mat-card-header>
                    <mat-card-content>
                        <div *ngFor="let personal of personaldetails">
                            <div>
                                <h5 class="csp3">Joint Holder</h5>
                                <div *ngIf="showProfile && personal.JH1_NAME; then Jointavail; else Jointdata">
                                </div>
                                <ng-template #Jointdata>
                                    <p>{{jointholder}}</p>
                                </ng-template>
                                <ng-template #Jointavail>
                                    <p>{{jointholder}}</p>
                                </ng-template>
                                <hr>
                                <h5 class="csp3">nominee</h5>
                                <div *ngIf="showProfile && personal.NM1_NAME; then nomineeavail; else nonominee">
                                </div>
                                <ng-template #nonominee>
                                    <p>{{nomineee}}</p>
                                </ng-template>
                                <ng-template #nomineeavail>
                                    <p>{{nomineee}}</p>
                                </ng-template>
                                <hr>
                                <h5 class="csp3">Mode of holding</h5>
                                <div *ngIf="showProfile && personal.HOLDING_NATURE; then holdingavail; else noholding">
                                </div>
                                <ng-template #noholding>
                                    <p>Not Applicable</p>
                                </ng-template>
                                <ng-template #holdingavail>
                                    <p>{{personal.HOLDING_NATURE}}</p>
                                </ng-template>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>

</div>